import axios from 'axios';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';

const useRejectScoringProjectModule = () => {
  const { mutate, isLoading } = useMutation(async ({ moduleId, projectId }) => {
    return await axios.post(`/standardization/${projectId}/modules/${moduleId}/reject`);
  });

  const rejectModuleScoring = (module, projectId, options) => {
    mutate(
      { moduleId: module.id, projectId },
      {
        onSuccess: (res) => {
          options?.onSuccess && options.onSuccess(module.id);
          toast.success('Successfully rejected the scoring of the module!');
        },
      }
    );
  };

  return {
    rejectModuleScoring,
    isLoading,
  };
};

export default useRejectScoringProjectModule;
